export default "__VITE_ASSET__CKwY9cWb__"